import { axiosInstance } from "../../Utils/AxiosInstance";

const BASE = "/Procurement/QuoteComparison";

const call = async (fn) => {
  try {
    const response = await fn();
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetAllComparisonsApi = (projectId) =>
  call(() => axiosInstance.get(`${BASE}/GetAll${projectId ? `?projectId=${projectId}` : ""}`));

export const GetComparisonByIdApi = (id) => call(() => axiosInstance.get(`${BASE}/GetById/${id}`));

export const GetComparisonCandidatesApi = (prId) =>
  call(() => axiosInstance.get(`${BASE}/GetCandidates/${prId}`));

// Direct comparison (no requisition): the project's quotes without a requisition.
export const GetDirectCandidatesApi = (projectId) =>
  call(() => axiosInstance.get(`${BASE}/GetDirectCandidates/${projectId}`));

// data: { PurchaseRequisitionId?, ProjectId?, ComparisonDate, Narration, QuoteIds[], Lines[{PurchaseRequisitionLineId, WinnerQuoteLineId, Quantity, Reason}], ApproverUserIds[] }
export const CreateComparisonApi = (data) => call(() => axiosInstance.post(`${BASE}/Create`, data));

export const EditComparisonApi = (id, data) =>
  call(() => axiosInstance.put(`${BASE}/Edit/${id}`, data));

export const UpdateComparisonApprovalApi = (approvalId, status, comments) =>
  call(() =>
    axiosInstance.put(`${BASE}/UpdateApproval/${approvalId}`, null, {
      params: { status, comments },
    }),
  );

export const DeleteComparisonApi = (id) => call(() => axiosInstance.delete(`${BASE}/Delete/${id}`));
